import * as commonScripts from '../common'
const cmpVideoCardsQumu = {
  component: null,

  init: function (element) {
    const _ = this
    _.component = element
    commonScripts.util.inheritPermalink(element)
    commonScripts.util.animationTranslate(this)

    const mediaContainer = _.component.querySelectorAll('.cmp-video-cards-qumu__card-list__item__media-container')
    const loadMoreBtn = _.component.querySelector('.cmp-video-cards-qumu__load-more-cta button')
    const videoCardItems = _.component.querySelectorAll('.cmp-video-cards-qumu__card-list__item.cmp-video-cards-qumu__card-list__item--clickable')
    const listItems = _.component.querySelectorAll('.cmp-video-cards-qumu__card-list__item')

    function handler () {
      if (mediaContainer) {
        for (let i = 0; i < mediaContainer.length; i++) {
          mediaContainer[i].style.height = (mediaContainer[i].offsetWidth * 0.75) + 'px'
        }
      }
    }

    if (window.addEventListener) {
      window.addEventListener('DOMContentLoaded', handler, false)
      window.addEventListener('load', handler, false)
      window.addEventListener('resize', handler, false)
    }

    const loadMoreCount = document.querySelector('.cmp-video-cards-qumu__load-more-cta').getAttribute('data-item-count')
    // console.log('Items to display:', loadMoreCount)
    //console.log(videoCardItems.length)
    const itemsDisplay = (loadMoreCount != 0 && loadMoreCount != null) ? parseInt(loadMoreCount) : 6
    let page = 0
    //console.log(videoCardItems.length)
    //console.log(itemsDisplay, " items to display")
    if (videoCardItems.length > itemsDisplay) {
      for (let index = itemsDisplay; index < videoCardItems.length; index++) {
        videoCardItems[index].classList.add('d-none')
      }
      page = 1
      if (loadMoreBtn) {
        loadMoreBtn.classList.remove('d-none')
      }
    }

    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', function (event) {
        page++
        for (let index = 0; index < page * itemsDisplay; index++) {
          if (videoCardItems[index]) {
            videoCardItems[index].classList.remove('d-none')
          }
        }
        if (page * itemsDisplay >= videoCardItems.length) {
          loadMoreBtn.classList.add('d-none')
        }
        // fire resize so videos resize?
        const evt = window.document.createEvent('UIEvents')
        evt.initUIEvent('resize', true, false, window, 0)
        window.dispatchEvent(evt)
      })
    }

    listItems.forEach((listItem) => {
      listItem.addEventListener('click', function (e) {
        // Check for and handle inline videos
        const video = this.querySelector('video')
        if (video) {
          const poster = this.querySelector(
            '.cmp-video-cards-qumu__card-list__item__media-container__video-poster'
          )
          poster.classList.add('d-none')
          video.classList.remove('d-none')
          video.play()
        }
        // Check for and handle popup videos
        const button = this.querySelector('button')
        if (button) {
          button.click()
        }
      })
    })
  }
}

export default cmpVideoCardsQumu
